import { styled } from '@mui/material/styles';

export const ManageDataContainer = styled('div')(({ theme }) => ({
  margin: '0 auto',
  maxWidth: theme.breakpoints.values.lg,
  padding: theme.spacing(4),
  '& a': {
    color: theme.palette.secondary.main,
  },
}));

export const TierBox = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(3)} 0`,
}));
